// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2G1wH","buttons":"styles_buttons__1KiL6"};